<template>
  <ul :class="{ 'pt-1': type === 'numbers' }">
    <li
      v-for="(item, i) in items"
      :key="i"
      :class="type === 'numbers' ? 'py-1' : 'mb-2 last:mb-0 font-medium'"
    >
      <component
        :is="item.link ? 'a' : 'div'"
        class="flex gap-2"
        :class="[
          type === 'numbers' ? 'items-center' : '',
          twMerge('leading-5 font-medium', listClasses),
        ]"
        :href="item.link"
        @click.prevent="item.link && scrollToSection(item.link)"
      >
        <span
          v-if="type === 'numbers'"
          class="w-6 shrink-0 text-right text-base font-medium leading-6 tracking-[0.32px] text-lime-700"
        >
          {{ i + 1 }}.
        </span>

        <component
          :is="
            camelCase(
              `icon-${summaryListGetters
                .getItemIconClassName(item)
                .replace('bi bi-', '')}`
            )
          "
          v-if="type === 'icons'"
          class="w-5 h-5"
        />

        <div class="flex-1 min-w-0">
          <div
            :class="
              type === 'numbers'
                ? 'text-[13px] font-medium leading-normal text-stone-900'
                : ''
            "
          >
            {{ summaryListGetters.getItemLabel(item) }}
          </div>
          <div
            v-if="summaryListGetters.getItemDescription(item)"
            class="text-sm leading-5 mt-2 font-normal"
          >
            {{ summaryListGetters.getItemDescription(item) }}
          </div>
        </div>
      </component>
    </li>
  </ul>
</template>

<script lang="ts">
import { twMerge } from 'tailwind-merge'
import camelCase from 'lodash/camelCase'
import {
  IconPeopleFill,
  IconBrushFill,
  IconBarChartFill,
  IconCupFill,
} from '#components'

export default {
  name: 'MagazineSummaryList',
  components: {
    IconPeopleFill,
    IconBrushFill,
    IconBarChartFill,
    IconCupFill,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'icons',
    },
    listClasses: {
      type: String,
      default: '',
    },
  },
  data() {
    return { summaryListGetters, camelCase }
  },
  methods: {
    twMerge,
    scrollToSection(link: string) {
      const sectionId = link.slice(1)
      const el = document.getElementById(sectionId)
      if (!el) return

      window.scrollTo({
        // subract 130 to account for navbar
        top: el.offsetTop - 130,
        behavior: 'smooth',
      })
    },
  },
}
</script>
